module.exports = __webpack_public_path__ + "static/media/Milan&Zorana.28cfb6d6.jpg";